<template>
    <div id="burger" :class="{ 'active' : isBurgerActive }" @click.prevent="toggle">
        <button type="button" class="burger-button" title="Menu">
            <span class="burger-bar burger-bar--1"></span>
            <span class="burger-bar burger-bar--2"></span>
            <span class="burger-bar burger-bar--3"></span>
        </button>
    </div>
</template>
<script>
    import { store, mutations } from "../../store.js";

    export default {
        name: "Burger",
        computed: {
            isBurgerActive() {
                return store.isNavOpen;
            }
        },
        methods: {
            toggle() {
                mutations.toggleNav();
            }
        }
    };
</script>
<style>

    button {
        cursor: pointer;
        background: transparent !important;
    }

    button:focus {
        outline: none;
    }

    .burger-button {
        position: relative;
        height: 30px;
        width: 32px;
        display: block;
        z-index: 999999;
        border: 0;
        background-color: transparent;
        border-radius: 0;
        pointer-events: all;
        transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
        outline: none !important;
    }

    .burger-button::after {
        position: absolute;
        content: "";
        display: block;
        height: 50px;
        width: 50px;
        top: -10px;
        left: -9px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.2);
        z-index: -1;
    }
    .burger-button:hover::after {
        background: white;
    }
    .burger-bar {
        background-color: navy;
        position: absolute;
        top: 50%;
        right: 6px;
        left: 6px;
        height: 3px;
        width: auto;
        margin-top: -1px;
        transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
        opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1),
        background-color 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    }
    .burger-bar--1 {
        -webkit-transform: translateY(-6px);
        transform: translateY(-6px);
    }

    .burger-bar--2 {
        transform-origin: 100% 50%;
        transform: scaleX(0.8);
    }

    .burger-button:hover .burger-bar--2 {
        transform: scaleX(1);
    }

    .no-touchevents .burger-bar--2:hover {
        transform: scaleX(1);
    }

    .burger-bar--3 {
        transform: translateY(6px);
    }

    #burger.active .burger-button {
        transform: rotate(-180deg);
    }

    #burger.active .burger-bar {
        background-color: navy;
    }

    #burger.active .burger-bar--1 {
        transform: rotate(45deg);
    }

    #burger.active .burger-bar--2 {
        opacity: 0;
    }

    #burger.active .burger-bar--3 {
        transform: rotate(-45deg);
    }
</style>
